const styles = {
  backButton: {
    '& .MuiSvgIcon-root': {
      fontSize: { xs: 16, sm: 18 },
      ml: 0.5,
    },
  },

  textContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  summaryList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '&.active .MuiListItemText-root:last-child': {
      '& p': {
        fontWeight: '600!important',
      },
    },
    '&.offers': {
      padding: 2,
    },
  },

  summaryListItem: {
    flex: 'initial',
    '& p': {
      marginRight: 0.5,
      textTransform: 'capitalize',
      fontSize: '13px!important',
      fontWeight: '600!important',
    },
    ':nth-of-type(+n+2)': {
      'p:before': {
        content: '" • "',
        fontWeight: '600',
      },
    },
    '&.active': {
      '& p': {
        fontWeight: '600',
      },
    },
    ':last-child': {
      '& p': {
        fontWeight: '600',
      },
    },
  },

  summaryListItemNoCapitalize: {
    flex: 'initial',
    '& p': {
      marginRight: 0.5,
    },
    ':nth-of-type(+n+2)': {
      'p::before': {
        content: '" • "',
      },
    },
    '&.active': {
      '& p': {
        fontWeight: '600',
      },
    },
    ':last-child': {
      '& p': {
        fontWeight: '600',
      },
    },
  },

  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiLinearProgress-root': {
      width: '100%',
    },
  },

  linearProgressWrapper: {
    width: '100%',
    backgroundColor: { md: 'white' },
    overflow: { md: 'hidden' },
    left: { xs: 0, md: 'unset' },
    top: { xs: 0, md: 'unset' },
  },

  linearProgress: {
    borderRadius: 8,
    backgroundColor: 'background.highlight',
    boxSizing: 'content-box',
    flexGrow: 1,
    height: 3,
  },

  summaryTextContainer: {
    marginTop: 1,
    '& span': {
      fontWeight: '600!important',
    },
    '& span:nth-of-type(+n+2)': {
      ':before': {
        content: '" • "',
        fontWeight: '600',
      },
    },

  },
}

export default styles
